import { finishLogin, trackGoogleSignupConversion } from './session'
import { getDeviceId } from '@/utils/device-id'
import { segmentTrack } from '@/utils'

export function providerLabel (provider) {
  return provider === 'apple' ? 'Apple' : 'Google'
}

/**
 * Exchange a Google or Apple code and route on the backend's answer. Shared by the signup and login
 * pages. `name` and `nonce` are Apple's (first-sign-in name, popup nonce). Returns an error message
 * to show inline, or '' when the page navigated.
 */
export async function exchangeSocialCode (vm, { provider = 'google', code, name = '', nonce = '', intent, redirect = '' }) {
  const store = vm.$store
  const signup = store.state.signup
  const response = await store.dispatch('socialExchange', {
    provider, credential: code, intent, deviceId: getDeviceId(),
    ...(name ? { name } : {}), ...(nonce ? { nonce } : {}),
  })
  const data = response.data || {}
  switch (data.action) {
    case 'LOGIN':
      await finishLogin(vm, { token: data.token, user: data.user }, {
        event: 'login', eventData: { method: provider }, redirect,
      })
      return ''
    case 'SIGNUP_COMPLETE':
      trackGoogleSignupConversion()
      store.commit('signup/clearPending')
      await finishLogin(vm, { token: data.token, user: data.user }, {
        event: 'signup_verified', eventData: { method: provider, entry: signup.entry },
        redirect: signup.plan && signup.plan.code ? '/plans/checkout' : '/plans',
      })
      return ''
    case 'NEEDS_CONFIRMATION':
      store.commit('signup/patch', {
        provider, email: (data.profile && data.profile.email) || signup.email,
        social: { profile: data.profile, socialToken: data.socialToken, intent: data.intent || intent },
      })
      segmentTrack('signup_started', { email: data.profile && data.profile.email, method: provider, entry: signup.entry })
      vm.$router.push('/register/social')
      return ''
    case 'ACCOUNT_EXISTS_PASSWORD':
      store.commit('signup/patch', {
        provider, email: data.email || (data.profile && data.profile.email),
        social: { profile: data.profile, intent, isSubAccount: data.isSubAccount === true }, linkToken: data.linkToken, redirect,
      })
      vm.$router.push('/register/exists')
      return ''
    case 'ACCOUNT_EXISTS_SUB_ACCOUNT':
      return data.msg || 'This email already has a POP sub-account. Log in with it, or use a different email to get your own subscription.'
    case 'ACCOUNT_EXISTS_SOCIAL':
      return 'This email already has a POP account that signs in another way. Log in with that method, or use your email and password.'
    default:
      return data.msg || `${providerLabel(provider)} sign-in didn't complete. Please try again.`
  }
}
